import React from 'react';
import SecureImage from '../../../../components/BucketImage/Image';
import { vehicle } from '../../../../common/svg';
import CountCard from '../../../../components/CounterCard';
import WeightCard from '../../../../components/Card/WeightCard';

const ContainerStatusTracker = () => {
  return (
    <div className="rounded-lg  w-full max-w-4xl ">
      <div className="font-[600] text-[14px] mb-10">Container Status</div>
      
      {/* Timeline Container */}
      <div className="relative mb-2">
        {/* Main Timeline */}
        <div className="relative flex items-center w-full">
          {/* Time markers above timeline */}
          <div className="absolute -top-8 flex justify-between w-full">
            <div className="text-gray-500 text-sm">05:30 am</div>
            <div className="text-gray-500 text-sm ml-4">09:30 am</div>
            <div className="text-gray-500 text-sm ml-6">10:30 am</div>
            <div className="text-gray-500 text-sm"></div>
          </div>
          
          {/* Progress dots and lines */}
          <div className="flex items-center w-full">
            {/* First segment (green/completed) */}
            <div className="w-2 h-2 bg-green-500 rounded-full z-10"></div>
            <div className="flex-1 h-0.5 bg-green-500"></div>
            
            {/* Second segment (green/completed) */}
            <div className="w-2 h-2 bg-green-500 rounded-full z-10"></div>
            <div className="flex-1 h-0.5 bg-green-500"></div>
            
            {/* Third segment (in progress) */}
            <div className="w-2 h-2 bg-green-500 rounded-full z-10"></div>
            <div className="flex-1 h-0.5 border-t border-dashed border-blue-700"></div>
            
            {/* Final destination */}
            <div className="w-2 h-2 bg-blue-700 rounded-full z-10"></div>
          </div>
          
          {/* Truck position */}
          <div className="absolute -top-12 left-[42%] transform">
            <div className="relative">
              <SecureImage

                          fileKey={vehicle}
                          alt="header icon"
                          width="80px"
                          />
              <div className="absolute -top-1 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
            </div>
          </div>
          
          {/* Status bubble */}
          <div className="absolute -top-24 right-1/3 transform translate-x-10">
            <div className="bg-blue-700 text-white py-2 px-4 rounded-lg text-sm">
              <div>Kms : 15 Km</div>
              <div>ETA : 1 hr 10 min</div>
              <div className="absolute bottom-[-6px] left-1/2 transform -translate-x-1/2 w-3 h-3 rotate-45 bg-blue-700"></div>
            </div>
          </div>
        </div>
        
        {/* Location Labels */}
        <div className="flex justify-between w-full mt-4">
          <div className="flex flex-col items-start">
            <div className="font-medium text-[14px]">Chennai</div>
            <div className="text-gray-500 text-sm">Pickup Point</div>
          </div>
          <div className="flex flex-col items-start ml-4">
            <div className="font-medium text-[14px]">Ennore</div>
            <div className="text-gray-500 text-sm">Loading Port</div>
          </div>
          <div className="flex flex-col items-center">
            <div className="font-medium text-[14px]">Ennore</div>
            <div className="text-gray-500 text-sm">Delivery Port</div>
          </div>
          <div className="flex flex-col items-end">
            <div className="font-medium text-[14px]">Ennore</div>
            <div className="text-gray-500 text-sm">Drop Point</div>
          </div>
        </div>
        
        {/* Trip details */}
        <div className="flex justify-start w-full gap-2 mt-1 whitespace-nowrap ">
          <WeightCard
          label=" Cargo Volume"
        weight={45}
        unit="Tons"
        date={new Date("2024-07-30T18:16:00")}
        themeColor="red"/>
          <WeightCard
          label="Empty Weight"
        weight={45}
        unit="Tons"
        date={new Date("2024-07-30T18:16:00")}
        themeColor="red"/>
          <WeightCard
          label="Cargo Count"
        weight={45}
        unit="Tons"
        date={new Date("2024-07-30T18:16:00")}
        themeColor="red"/>
        </div>

        <div className="flex justify-between w-full gap-2 mt-3">
          <div>
            <p className=''>Container Specification</p>
            <div className='border border-gray-300 rounded-lg h-[100px] w-[400px] p-2'>
              Container Specification
            </div>
          </div>
          <div>
            <p className=''>Remark</p>
            <div className='border border-gray-300 rounded-lg h-[100px] w-[400px] p-2'>
              Remark
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContainerStatusTracker;